import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { cargarCatalogosAsync } from '../../funciones_globales/catalogos';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';

class FormVen10  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fechaDesde: null,
            fechaHasta: null,            
            zona_sel: null,
            tipoCompra_sel: null,
            esResumido: false
        };
        
        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.generarReporteArticulosVendPorZona = this.generarReporteArticulosVendPorZona.bind(this);
    }
    
    componentDidMount(){
        Promise.all([
            this.props.generar_LogAuditoriaIngresoForm('0410')
         ])
        .then(() => {
            let fechaHasta = moment(this.props.fechaProceso, "DD/MM/YYYY");
            let fechaDesde = fechaHasta.subtract(31, 'days');
            this.setState({fechaDesde: fechaDesde, fechaHasta: moment(this.props.fechaProceso, "DD/MM/YYYY")});
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0410');
    }

    getOptions_Ciudad(input, callback){
        if (input.toString().length >= 2 ){
            cargarCatalogosAsync('CIUDAD', input, callback)
        }
    }

    getOptions_TiposCompra(input, callback){
        if (input.toString().length >= 2 ){
          cargarCatalogosAsync('TIPOPRECIO', input, callback)
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    generarReporteArticulosVendPorZona(){        
        try {

            let fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
            if (!validarFechaMomentEnFormatoString(fechaDesde)){
                alert('La fecha Desde es inválida.');
                return;
            }
            
            let fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);
            if (!validarFechaMomentEnFormatoString(fechaHasta)){
                alert('La fecha Hasta es inválida.');
                return;
            }

            if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){        
                alert(`La fecha Desde debe ser menor a: ${formatearFechaMoment_a_String(this.state.fechaHasta)}`);
                return;
            }
            
            let urlReportWithParams=`&rpt=${(this.state.esResumido===true?'36':'35')}`;
            urlReportWithParams+=`&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`;

            if(this.state.tipoCompra_sel!==null){
                urlReportWithParams+=`&param3=${this.state.tipoCompra_sel.value}`;
            }

            if(this.state.zona_sel!==null){
                urlReportWithParams+=`&param4=${this.state.zona_sel.value}`;
            }

            visualizarReporteEnPdf(urlReportWithParams);
        } catch (error) {
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    limpiar(){        
        let fechaHasta = moment(this.props.fechaProceso, "DD/MM/YYYY");
        let fechaDesde = fechaHasta.subtract(31, 'days');
        this.setState({ fechaDesde: fechaDesde,
                        fechaHasta: moment(this.props.fechaProceso, "DD/MM/YYYY"),
                        zona_sel: null,
                        tipoCompra_sel: null,
                        esResumido: false
                    });
    }

    render(){
        return (
            <ContenedorForm porc_ancho={70}>
            <HeaderForm>
                <TituloForm>Artículos vendidos por Categoría</TituloForm>
            </HeaderForm>
                <CuerpoForm>                    
                    <Row>
                        <ContainerCol className='col-md-2' margen_arriba={10}>
                            <LabelForm>Fecha Desde:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fecha)=>{this.setState({fechaDesde: fecha});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-2' margen_arriba={10}>
                            <LabelForm>Fecha Hasta:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fecha)=>{this.setState({fechaHasta: fecha});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-4' margen_arriba={10}>
                            <LabelForm>Categoría:</LabelForm>
                            <ReactSelectAsync value={this.state.tipoCompra_sel} func_loadOptions={this.getOptions_TiposCompra} func_onChange={(value)=>{this.setState({tipoCompra_sel: value});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-4' margen_arriba={10}>
                            <LabelForm>Zona:</LabelForm>
                            <ReactSelectAsync value={this.state.zona_sel} func_loadOptions={this.getOptions_Ciudad} func_onChange={(value)=>{this.setState({zona_sel: value});}}/>
                        </ContainerCol>                        
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2' margen_arriba={10}>
                            <LabelForm><input type='checkbox' name='esResumido' checked={this.state.esResumido}
                                onChange={this.handleInputChange}/> Resumido</LabelForm>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12' margen_arriba={10}>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.generarReporteArticulosVendPorZona}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {fechaProceso: state.sesion.valoresSesionForm.FechaProceso,
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario
        }
});
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormVen10);